<script>
import detail from "./components/detail.vue"

export default {
  name: "Map",
  components: { detail },
  data() {
    return {
      data: [],
      page: {
        total: 0,
        size: 20,
        current: 1
      },
      loading: false,
      userPhone: '',
      payState: '',
      state: ''
    }
  },
  mounted() {
    this.init()
    this.$validate.ToDocumentTitle()
  },
  methods: {
    init() {
      this.$set(this, 'loading', true)
      const params = {
        params: {
          pageNumber: this.page.current,
          pageSize: this.page.size,
          userPhone: this.userPhone || undefined,
          payState: this.payState || undefined,
          state: this.state || undefined
        }
      }
      this.$axios.get('/account/user/subscription/manager/list', params).then((res) => {
        this.$set(this, 'loading', false)
        this.$set(this, 'data', res.data.data.list)
        this.$set(this.page, 'total', res.data.data.total)
      }).catch(() => {
        this.$set(this, 'loading', false)
      })
    },
    setCreate() {
      const e = {
        data: {
          productCode: 'SHOP_MAP',
          state: 'Subscribe',
        },
        name: '创建地图用户订阅'
      }
      this.$refs.detail.display(e)
    },
    setUpdate(row) {
      const e = {
        data: row,
        name: '修改地图用户订阅'
      }
      this.$refs.detail.display(e)
    },
    setSubscribe(row) {
      const e = {
        data: { ...row, state: 'Subscribe', dayNumber: 7 },
        name: '订阅地图用户',
        isSubscribe: true
      }
      this.$refs.detail.display(e)
    },
    handleSizeChange(val) {
      this.page.size = val
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.init()
    },
    fetchInit() {
      this.page.current = 1
      this.init()
    }
  }
}
</script>

<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px">
      <div class="fl">
        <el-button type="primary" @click="setCreate()" size="mini">创建</el-button>
        <el-input v-model="userPhone" @change="fetchInit()" style="width: 150px; margin-left: 10px;" placeholder="手机号"
          clearable size="mini"></el-input>
        <el-select v-model="state" @change="fetchInit()" style="width: 150px; margin-left: 10px;" placeholder="订阅状态"
          clearable size="mini">
          <el-option v-for="item in [{ value: 'Subscribe', label: '已订阅' }, { value: 'NotSubscribe', label: '未订阅' }]"
            :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <el-select v-model="payState" @change="fetchInit()" style="width: 150px; margin-left: 10px;" placeholder="支付状态"
          clearable size="mini">
          <el-option v-for="item in [{ value: 'SUCCESS', label: '支付完成' }, { value: 'NotPay', label: '未支付' }]"
            :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="80%" v-loading="loading"
      highlight-current-row>
      <template #empty>
        <el-empty></el-empty>
      </template>
      <el-table-column prop="userName" label="用户名" min-width="100" show-overflow-tooltip align="center" />
      <el-table-column prop="userPhone" label="手机号" width="100" show-overflow-tooltip align="center" />
      <el-table-column prop="state" label="状态" width="80" show-overflow-tooltip align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.state === 'NotSubscribe' ? 'danger' : 'success'" size="mini" v-if="scope.row.state">
            {{ scope.row.state === 'NotSubscribe' ? '未订阅' : '已订阅' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="subscribeStartTime" label="开始时间" width="140" align="center" />
      <el-table-column prop="subscribeEndTime" label="结束时间" width="140" align="center" />
      <el-table-column prop="payCode" label="支付编号" width="180" show-overflow-tooltip align="center" />
      <el-table-column prop="payState" label="支付状态" width="100" show-overflow-tooltip align="center">
        <template v-slot="scope">
          <el-tag :type="scope.row.payState === 'USERPAYING' ? 'danger' : 'success'" size="mini"
            v-if="scope.row.payState">
            {{ scope.row.payState === 'USERPAYING' ? '支付中' : '支付完成' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="freeTrialTimes" label="剩余体验次数" width="100" align="center"></el-table-column>
      <el-table-column prop="payAmount" label="支付金额" width="100" align="center">
        <template #default="scope">
          {{ scope.row.payAmount ? scope.row.payAmount + ' 元' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="payFinishTime" label="支付时间" width="140" align="center" />
      <el-table-column prop="createTime" label="创建时间" width="140" align="center" />
      <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip align="center" />
      <el-table-column fixed="right" width="100" label="操作" align="center">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="setUpdate(scope.row)">修改</el-button>
          <el-button v-if="scope.row.state === 'NotSubscribe'" size="mini" type="text" @click="setSubscribe(scope.row)">
            订阅
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: left; padding: 10px 0">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.current"
        :page-sizes="[20, 50, 80, 100, 200]" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper"
        :total="page.total" background>
      </el-pagination>
    </div>
    <detail ref="detail" @init="init()" />
  </div>
</template>

<style scoped></style>
